import React from 'react'

import FacebookAdPreviewContainer from '../reusablePreviewComponents/FacebookAdPreviewContainer'
import FacebookAdPreviewHeader from '../reusablePreviewComponents/FacebookAdPreviewHeader'
import FacebookExistingPostMediaThumbnail from './FacebookExistingPostMediaThumbnail'

import { AD_TEXT, TEXT_BLANK, TEXT_ENTER, TEXT_OPTION } from '../../../../forms/Facebook/AdForms/fields'
import { FILE_URL } from '../../../../forms/ReusableFormFields/AdFileUpload/fields'

function FacebookExistingPostPreview({ values, isInProgress }) {
  const formikValues = {
    ...values,
    [TEXT_OPTION]: values[AD_TEXT] ? TEXT_ENTER : TEXT_BLANK
  }

  const mediaUrl = formikValues[FILE_URL]

  return (
    <FacebookAdPreviewContainer>
      <FacebookAdPreviewHeader formikValues={formikValues} />
      <FacebookExistingPostMediaThumbnail isInProgress={isInProgress} mediaUrl={mediaUrl} />
    </FacebookAdPreviewContainer>
  )
}

export default FacebookExistingPostPreview
